import {NotificationService} from "../../services/NotificationService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {CheckoutHistoryService} from "../../services/CheckoutHistoryService";

export class ReportCheckoutHistoryModel {
    static $inject = ['$q', '$filter' ,'FileSaver','Blob','CheckoutHistoryService','CustomFieldNameService','NotificationService'];
    errorMessage:string = "";
    assetname:string = "";
    username: string = "";
    startDate: string = "";
    endDate: string = "";
    totalCount:number = 0;
    constructor(public $q: ng.IQService,
                public $filter: ng.IFilterService,
                public fileSaver:any,
                public blob:any,
                public chService:CheckoutHistoryService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
        this.getCount();
    }
    getReport():ng.IPromise<any>{
        var strStart = this.$filter('date')(this.startDate, "yyyy-MM-dd");
        var strEnd = this.$filter('date')(this.endDate, "yyyy-MM-dd");
        return this.chService.getReport(this.assetname, this.username, strStart, strEnd).then((data)=>{
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'checkoutHistory.xlsx');
        })
            .catch((exc)=>{
                this.notifyService.notify("getReport err:"+exc);
            });
        return this.$q.when();
    }
    getCount():ng.IPromise<any>{
        var strStart = this.$filter('date')(this.startDate, "yyyy-MM-dd");
        var strEnd = this.$filter('date')(this.endDate, "yyyy-MM-dd");
        return this.chService.getReportCount(this.assetname, this.username, strStart, strEnd)
            .then((data)=>{
                this.totalCount = data;
            }).catch((exc)=>{
                this.notifyService.notify("Exception in getCount-"+exc);
            });
    }

}
